var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarToday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2539_2414",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#A4A4A4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2539_2414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53851 14.3333C3.20175 14.3333 2.91671 14.2167 2.68337 13.9833C2.45004 13.75 2.33337 13.465 2.33337 13.1282V4.20517C2.33337 3.86841 2.45004 3.58337 2.68337 3.35003C2.91671 3.1167 3.20175 3.00003 3.53851 3.00003H4.46159V1.58978H5.48721V3.00003H10.5385V1.58978H11.5385V3.00003H12.4615C12.7983 3.00003 13.0833 3.1167 13.3167 3.35003C13.55 3.58337 13.6667 3.86841 13.6667 4.20517V13.1282C13.6667 13.465 13.55 13.75 13.3167 13.9833C13.0833 14.2167 12.7983 14.3333 12.4615 14.3333H3.53851ZM3.53851 13.3334H12.4615C12.5128 13.3334 12.5598 13.312 12.6026 13.2693C12.6453 13.2265 12.6667 13.1795 12.6667 13.1282V6.87183H3.33336V13.1282C3.33336 13.1795 3.35472 13.2265 3.39746 13.2693C3.4402 13.312 3.48722 13.3334 3.53851 13.3334ZM3.33336 5.87185H12.6667V4.20517C12.6667 4.15388 12.6453 4.10686 12.6026 4.06412C12.5598 4.02138 12.5128 4.00002 12.4615 4.00002H3.53851C3.48722 4.00002 3.4402 4.02138 3.39746 4.06412C3.35472 4.10686 3.33336 4.15388 3.33336 4.20517V5.87185Z",
    fill: "#A4A4A4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/calendar_today.adbde726728fad6b7ad3cce9b85f54f0.svg";
export { ForwardRef as ReactComponent };